import { Injectable } from "@angular/core";
import { B2bCheckoutService } from "b2b-ecommerce-lib";

@Injectable({
  providedIn: "root",
})
export class PaymentService extends B2bCheckoutService {}
